import styles from './index.module.scss';
import commonStyles from './../common.module.scss';
import './../tabs.scss';
import './../popups.scss';
import { formatAmount, formatTime, renderDurationMinutesDisplay } from '../../../../../utils';
import { useRef, useState } from "react";
import { Pagination, Tabs } from 'antd';
import classNames from 'classnames';
import CardContainer from '../CardContainer';
import CardHeader from '../CardHeader';
import CardBody from '../CardBody';
import { SettingsIcon } from '../../../../common/Icons';
import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { getCollaboratorProcessingTime } from '../../../../../api';
import { ConfirmPopup } from 'primereact/confirmpopup';
import Select from 'react-select';
import ProcessingTimeCardSkeleton from './skeleton';

export default function RespectProcessingTime({
  collaboratorId,
  selectedPeriod,
  year,
  typeData,
  isActive,
  clientsOptions,
  onAmountChange,
  onLoadingData
}) {
  const { token, navCommunity } = useSelector((state) => state.auth);
  const [processingTimeExcessData, setProcessingTimeExcessData] = useState([]);
  const [processingTimeNonExcessData, setProcessingTimeNonExcessData] = useState([]);
  const [processingTimeExcessDataToDisplay, setProcessingTimeExcessDataToDisplay] = useState([]);
  const [processingTimeNonExcessDataToDisplay, setProcessingTimeNonExcessDataToDisplay] = useState([]);
  const [processingTimeTotalExcessHours, setProcessingTimeTotalExcessHours] = useState(0);
  const [isAchieved, setIsAchieved] = useState(false);
  const [percentage, setPercentage] = useState(0);
  const [excessDataPagination, setExcessDataPagination] = useState({
    pageSize: 6,
    currentPage: 1
  });
  const [nonExcessDataPagination, setNonExcessDataPagination] = useState({
    pageSize: 6,
    currentPage: 1
  });
  const [filters, setFilters] = useState({
    excludedClients: []
  });
  const [filtersToParams, setFiltersToParams] = useState({
    excludedClients: []
  });
  const processingTimeFiltersIconRef = useRef(null);
  const [showFiltersModal, setShowFiltersModal] = useState(false);

  const getCollaboratorProcessingTimeQuery = useQuery(
    [
      "getCollaboratorProcessingTime",
      token,
      navCommunity,
      year,
      filtersToParams,
      collaboratorId,
      selectedPeriod,
    ],
    async () => {
      if (token && navCommunity && collaboratorId) {
        try {
          onLoadingData('rtt', true);

          const response = await getCollaboratorProcessingTime({
            token,
            organizationId: navCommunity.id,
            collaboratorId,
            categories: [4],
            startDate: `${year}-${selectedPeriod.start}`,
            endDate: `${year}-${selectedPeriod.end}`,
            excludedClients: filtersToParams.excludedClients.map(it => it.value),
          });
          const data = response.data.data.processingTimeData;
          const excessData = data?.filter(item => item.timesheet.ecart > 0);
          const nonExcessData = data?.filter(item => item.timesheet.ecart < 0)?.reverse();
          const processingTimeNumberOfExcess = response.data.data.numberOfExcess;
          const totalPositiveEcart = response.data.data.totalPositiveEcart;
          const totalNegativeEcart = response.data.data.totalNegativeEcart;
          setProcessingTimeExcessData(excessData);
          setProcessingTimeNonExcessData(nonExcessData);
          setProcessingTimeExcessDataToDisplay(excessData.slice(0, 6));
          setProcessingTimeNonExcessDataToDisplay(nonExcessData.slice(0, 6));
          setProcessingTimeTotalExcessHours(totalPositiveEcart + totalNegativeEcart);

          const isAchieved = (totalPositiveEcart + totalNegativeEcart) <= 0;
          const percentage = processingTimeNumberOfExcess === 0 ? 100 : (100 - (processingTimeNumberOfExcess * 100 / data.length));

          setIsAchieved(isAchieved);
          setPercentage(percentage);

          if (isAchieved) {
            onAmountChange('rtt', typeData.amount);
          } else {
            onAmountChange('rtt', 0);
          }
        } catch (e) {
          console.error(e);
          return null;
        } finally {
          onLoadingData('rtt', false);
        }
      }
    },
    {
      enabled: !!token && !!navCommunity && !!collaboratorId
    }
  );

  const renderPositiveGapsItems = () => {
    return (
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.client_list}>
            {processingTimeExcessDataToDisplay.map(item => (
              <div key={item.clientId} className={styles.client_card}>
                <p className={styles.client_name}>{item.clientName}</p>
                <span className={`${styles.client_gap} ${styles.client_gap_negatif}`}>
                  +{formatTime(item.timesheet.ecart, true)}
                </span>
              </div>
            ))}
          </div>

          <Pagination
            className={`${styles.pagination} bonus_custom_table_pagination`}
            pageSize={excessDataPagination.pageSize}
            current={excessDataPagination.currentPage}
            total={processingTimeExcessData.length}
            onChange={(page, pageSize) => {
              setExcessDataPagination({
                currentPage: page,
                pageSize
              })
              // const startIndex = (page - 1) * pageSize;
              // const endIndex = startIndex + pageSize;
              setProcessingTimeExcessDataToDisplay(
                processingTimeExcessData.slice(
                  (page - 1) * pageSize,
                  page * pageSize
                )
              );
            }}
            itemRender={(page, type) => {
              if (type === 'prev') {
                return (
                  <button
                    className={classNames({
                      'pagination_button': true,
                      'pagination_button_disabled': excessDataPagination.currentPage === 1
                    })}
                    disabled={excessDataPagination.currentPage === 1}
                  >
                    <svg width="6" height="10" viewBox="0 0 6 10" fill="none">
                      <path d="M5 9L1 5L5 1" stroke="#666666" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </button>
                );
              }
              if (type === 'next') {
                return (
                  <button
                    className={classNames({
                      'pagination_button': true,
                      'pagination_button_disabled': excessDataPagination.currentPage === processingTimeExcessData.length / excessDataPagination.pageSize
                    })}
                    disabled={excessDataPagination.currentPage * excessDataPagination.pageSize >= processingTimeExcessData.length}
                  >
                    <svg width="6" height="10" viewBox="0 0 6 10" fill="none">
                      <path d="M1 1L5 5L1 9" stroke="#666666" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </button>
                );
              }
              return null;
            }}
            showTotal={(total, range) => (
              <p className='pagination_total_text'>
                {Math.ceil(range[0] / 6)} sur {Math.ceil(total / 6)}
              </p>
            )}
          />
        </div>
        </div>
    )
  };

  const renderNegativeGapsItems = () => {
    return (
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.client_list}>
            {processingTimeNonExcessDataToDisplay.map(item => (
              <div key={item.clientId} className={styles.client_card}>
                <p className={styles.client_name}>{item.clientName}</p>
                <span className={`${styles.client_gap} ${styles.client_gap_positif}`}>
                  -{formatTime(Math.abs(item.timesheet.ecart), true)}
                </span>
              </div>
            ))}
          </div>

          <Pagination
            className={`${styles.pagination} bonus_custom_table_pagination`}
            pageSize={nonExcessDataPagination.pageSize}
            current={nonExcessDataPagination.currentPage}
            total={processingTimeNonExcessData.length}
            onChange={(page, pageSize) => {
              setNonExcessDataPagination({
                pageSize,
                currentPage: page
              });

              // const startIndex = (page - 1) * pageSize;
              // const endIndex = startIndex + pageSize;
              setProcessingTimeNonExcessDataToDisplay(
                processingTimeNonExcessData.slice(
                  (page - 1) * pageSize,
                  page * pageSize
                )
              );
            }}
            itemRender={(page, type) => {
              if (type === 'prev') {
                return (
                  <button
                    className={classNames({
                      'pagination_button': true,
                      'pagination_button_disabled': nonExcessDataPagination.currentPage === 1
                    })}
                    disabled={nonExcessDataPagination.currentPage === 1}
                  >
                    <svg width="6" height="10" viewBox="0 0 6 10" fill="none">
                      <path d="M5 9L1 5L5 1" stroke="#666666" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </button>
                );
              }
              if (type === 'next') {
                return (
                  <button
                    className={classNames({
                      'pagination_button': true,
                      'pagination_button_disabled': nonExcessDataPagination.currentPage === processingTimeNonExcessData.length / nonExcessDataPagination.pageSize
                    })}
                    disabled={nonExcessDataPagination.currentPage * nonExcessDataPagination.pageSize >= processingTimeNonExcessData.length}
                  >
                    <svg width="6" height="10" viewBox="0 0 6 10" fill="none">
                      <path d="M1 1L5 5L1 9" stroke="#666666" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </button>
                );
              }
              return null;
            }}
            showTotal={(total, range) => (
              <p className='pagination_total_text'>
                {Math.ceil(range[0] / 6)} sur {Math.ceil(total / 6)}
              </p>
            )}
          />
        </div>
      </div>
    )
  };

  if (getCollaboratorProcessingTimeQuery.isFetching) {
    return (
      <ProcessingTimeCardSkeleton />
    )
  }

  return (
    <CardContainer className={classNames({
      [styles.card]: true,
      [commonStyles.card_blured]: !isActive
    })}>
      <ConfirmPopup
        target={processingTimeFiltersIconRef.current}
        visible={showFiltersModal}
        acceptLabel="Appliquer"
        rejectLabel='Annuler'
        acceptClassName={commonStyles.filters_popup_accept_btn}
        rejectClassName={commonStyles.filters_popup_reject_btn}
        accept={() => {
          setFiltersToParams({...filters});
          setShowFiltersModal(false);
        }}
        reject={() => {
          setFilters({...filtersToParams});
          setShowFiltersModal(false);
        }}
        group="headless"
        className='bonus_custom_popup'
        dismissable={false}
        style={{ width: '400px', left: '-50px' }}
        message={
          <div>
            <div style={{ width: '100%' }}>
              <label>
                <span className="popup_label">Clients à ignorés</span>
                <Select
                  className="popup_select"
                  isMulti={true}
                  isSearchable={true}
                  isClearable={true}
                  isDisabled={false}
                  maxMenuHeight={220}
                  placeholder='Clients à ignorés'
                  options={clientsOptions}
                  value={filters.excludedClients}
                  onChange={(inputValue) =>
                    setFilters({ ...filters, excludedClients: inputValue })
                  }
                  styles={{ width: '300px' }}
                />
              </label>
            </div>
          </div>
        }
      />

      {!isActive && (
        <div className={commonStyles.blured_text}>
          Ce type de bonus n’est pas configuré pour la période choisie.
        </div>
      )}
      <CardHeader
        percentage={formatAmount(
          percentage,
          false
        )}
        amount={typeData.amount}
        isPositif={isAchieved}
        title={typeData.label}
        detailsBox={{
          value: (processingTimeTotalExcessHours > 0 ? '+' : '-') + renderDurationMinutesDisplay(Math.abs(processingTimeTotalExcessHours)),
          label: "Le temps de dépassement total.",
          isPositif: processingTimeTotalExcessHours <= 0,
        }}
      />
      <CardBody
        title={
          <div className={commonStyles.card_body_title}>
            <p>{typeData.description}</p>
            <div
              ref={processingTimeFiltersIconRef}
              className={commonStyles.card_filters}
              onClick={
                () =>
                  setShowFiltersModal(!showFiltersModal)
              }
            >
              <SettingsIcon fill="#000" />
            </div>
          </div>
        }
      >
        <Tabs
          size='small'
          className='bonus_custom_tabs'
          centered
          animated
          items={[
            {
              key: '1',
              label: 'Temps maîtrisé',
              children: renderNegativeGapsItems(),
            },
            {
              key: '2',
              active: true,
              label: 'Dépassements de temps',
              children: renderPositiveGapsItems(),
            },
          ]}
        />
      </CardBody>
    </CardContainer>
  );
}
